<section
  id="ePressDetails"
  class="rs-content-wrapper rs-header-has-level2"
  *ngIf="!hasError || ePressProductDetails || isPending"
>
  <mprd-epress-skeleton *ngIf="!ePressProductDetails"></mprd-epress-skeleton>
  <main id="maincontent" role="main" *ngIf="ePressProductDetails">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-tit1-sp rs-txt-c2">
            {{ ePressProductDetails?.productDescription }}
          </h1>
          <div class="rs-panel-big rs-bg-c2 clearfix">
            <px-alert [alertKey]="'swapPartnerAlert'"></px-alert>
            <h2 class="rs-tit3">{{ 'epress.subtitle' | translate }}</h2>
            <p>{{ 'epress.description' | translate }}</p>
            <div class="rs-flex-row" *ngIf="ePressProductDetails?.options?.length > 0">
              <div class="rs-flex-columns small-12">
                <div class="rs-slider rs-slider-s rs-padding-bottom2">
                  <ul class="rs-slides">
                    <li
                      mprd-epress-option
                      *ngFor="let option of ePressProductDetails.options; even as isEven"
                      [product]="ePressProductDetails"
                      [option]="option"
                      [ePressChange$]="ePressChange$"
                      (ePressOptionChange)="onEpressSwapChange()"
                      class="rs-slide small-12 medium-6"
                      [isEven]="isEven"
                    ></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="rs-le2"></div>
        </div>
      </div>
    </section>
  </main>
</section>
